<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close"
            (click)="activeModal.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Card Reader Payment</h4>
    <button type="button" class="close" aria-label="Close"
            *ngIf="state !== ModalState.initializingPayment"
            [disabled]="loadingCancelPayment"
            (click)="handleCloseAttempt()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="alert alert-danger" *ngIf="errorMessage !== ''">{{ errorMessage }}</div>
    <app-live-reader-refusal-alert *ngIf="liveReaderRefusal" [refusal]="liveReaderRefusal">
    </app-live-reader-refusal-alert>
    <div class="alert alert-info" *ngIf="loadingCancelPayment">Cancelling payment...</div>

    <ng-container *ngIf="state === ModalState.choosingReader">
      <label>Select card reader for payment:</label>

      <button class="btn btn-block btn-secondary" *ngIf="loadingReaders">Loading...</button>
      <ng-container *ngIf="!loadingReaders">
        <button class="btn btn-block btn-primary"
                *ngFor="let reader of readerList"
                (click)="selectReader(reader)">
          {{ reader.label }}
        </button>
        <button class="btn btn-block btn-secondary" *ngIf="!readerResultsPresent()">No card readers configured</button>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="state === ModalState.initializingPayment">
      <div class="alert alert-info">Sending payment to reader...</div>
    </ng-container>

    <ng-container *ngIf="state === ModalState.waitingForPayment">
      <div class="alert alert-info">Payment sent to reader. Please complete the payment using the card reader.</div>
    </ng-container>

    <ng-container *ngIf="state === ModalState.paymentFailed">
      <div class="alert alert-danger">Payment failed.</div>

      <button class="btn btn-block btn-primary" (click)="state = ModalState.choosingReader">Retry</button>
    </ng-container>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            *ngIf="state !== ModalState.initializingPayment"
            [disabled]="loadingCancelPayment"
            (click)="handleCloseAttempt()">
      {{ cancelRefused ? 'Close anyway' : 'Cancel' }}
    </button>
  </div>

</ng-container>
